import { render, staticRenderFns } from "./ShipmentTrackingReport.vue?vue&type=template&id=4f9cb9a8&scoped=true&"
import script from "./ShipmentTrackingReport.vue?vue&type=script&lang=js&"
export * from "./ShipmentTrackingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9cb9a8",
  null
  
)

export default component.exports